(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text-scroll"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // Desktop vertical
  if (window.innerWidth > 749) {
    const blocks = document.querySelectorAll('.sticky-image-scroll__content .sticky-image-scroll__block');
    const images = document.querySelectorAll('.sticky-image-scroll__media .scroll-img');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.dataset.blockId;
          images.forEach((img) => {
            img.classList.toggle('active', img.dataset.blockId === id);
          });
        }
      });
    }, { threshold: 0.5 });

    blocks.forEach((block) => observer.observe(block));
  }

  // Mobile horizontal with pagination
  if (window.innerWidth <= 749) {
    const content = document.querySelector('.sticky-image-scroll__mobile .sticky-image-scroll__content');
    const mobileBlocks = document.querySelectorAll('.sticky-image-scroll__mobile .sticky-image-scroll__block');
    const mobileImages = document.querySelectorAll('.sticky-image-scroll__mobile .scroll-img');
    const pagination = document.querySelector('.sticky-image-scroll__pagination');

    // Generate dots
    mobileBlocks.forEach((_, i) => {
      const dot = document.createElement('span');
      dot.className = 'dot' + (i === 0 ? ' active' : '');
      dot.dataset.index = i;
      pagination.appendChild(dot);
    });

    const dots = pagination.querySelectorAll('.dot');

    // Scroll observer
    const observerMobile = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.dataset.blockId;
          const index = [...mobileBlocks].indexOf(entry.target);

          // Update active image
          mobileImages.forEach((img) => {
            img.classList.toggle('active', img.dataset.blockId === id);
          });

          // Update active dot
          dots.forEach((dot, i) => {
            dot.classList.toggle('active', i === index);
          });
        }
      });
    }, {
      threshold: 0.6,
      root: content,
      rootMargin: '0px',
    });

    mobileBlocks.forEach((block) => observerMobile.observe(block));

    // Clickable dots
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.index, 10);
        content.scrollTo({
          left: mobileBlocks[index].offsetLeft,
          behavior: 'smooth'
        });
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recentview-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  let viewed = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];
  if (viewed.length === 0) return;

  viewed.forEach(product => {
    document.querySelectorAll(`[data-handle="${product.handle}"]`).forEach(el => {
      el.style.display = '';
    });
  });

  const swiperEl = document.querySelector('#recently-viewed-swiper');
  let swiperInstance = null;

  function initSwiper() {
    if (!swiperEl) return;
    if (window.innerWidth <= 749 && !swiperInstance) {
      swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 15,
        breakpoints: {
          0: {
            // slidesPerView: 1.5,
            spaceBetween: 20,
          },
          500: {
            // slidesPerView: 2.28,
            spaceBetween: 20,
          }
        },
      });
    } else if (window.innerWidth > 749 && swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  initSwiper();
  window.addEventListener('resize', initSwiper);
});

  } catch(e) { console.error(e); }
})();
})();
